var App = App || {};

App.PromoCards = (function ($) {
    "use strict";

    function init() {

        const promoCardsBands = $(".block.block-promo-cards");
        if (promoCardsBands.length) {
            promoCardsBands.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(promoCardsBand) {
        const carousel = promoCardsBand.find(".promo-cards-inner.mobile.splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: true,
                type: 'loop',
                fixedWidth: "281px",
                gap: "40px",
                drag: true,
                snap: false,
                perMove: 1
            });

            splideCarousel.mount();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PromoCards.init();
});